/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var ServiceFeatureFlagsProvider = /** @class */ (function () {
    function ServiceFeatureFlagsProvider(telemetryService, cds, services) {
        this.telemetryService = telemetryService;
        this.cds = cds;
        this.services = services;
    }
    ServiceFeatureFlagsProvider.prototype.getName = function () {
        return "service";
    };
    ServiceFeatureFlagsProvider.prototype.initialize = function () {
        var _this = this;
        var promises = [];
        this.services.forEach(function (serviceName) {
            promises.push(_this.getFeatureFlagsFromService(serviceName));
        });
        var mergedSet = new Map();
        return Promise.all(promises).then(function (featureFlags) {
            // Merge the array of feature flags into a single set
            featureFlags.forEach(function (flags) {
                for (var featureName in flags) {
                    var value = flags[featureName];
                    if (mergedSet.has(featureName)) {
                        // If two services have the same flag, the resultant
                        // flag should be the intersection (and) of the two values.
                        value = value && mergedSet.get(featureName);
                    }
                    mergedSet.set(featureName, value);
                }
            });
            _this.entries = mergedSet;
        });
    };
    ServiceFeatureFlagsProvider.prototype.isFeatureEnabled = function (flag, defaultValue) {
        if (!this.entries) {
            throw new Error("Cannot use service side feature flags before they are initialized!");
        }
        if (!flag.startsWith("clientui_")) {
            // Not supported
            return undefined;
        }
        if (this.entries.has(flag)) {
            return this.entries.get(flag);
        }
        this.telemetryService.logError("ServiceFeatureFlags: Request for undefined flag", { featureName: flag });
        // Default for missing flags on the service is 'true'.  This is because we have
        // some orgs that are upgraded rarely but the service is upgraded routinely,
        // so it's possible for a feature flag that is defined in the service to disappear.
        // We default to 'true' in this case since the most likely scenario is that the feature was 
        // enabled permanetly.  We also log this as an error so we can monitor for this situation.
        return defaultValue !== null && defaultValue !== void 0 ? defaultValue : true;
    };
    ServiceFeatureFlagsProvider.prototype.getEntriesInternal = function () {
        if (!this.entries) {
            throw new Error("Cannot use service side feature flags before they are initialized!");
        }
        return this.entries;
    };
    ServiceFeatureFlagsProvider.prototype.setEntriesInternal = function (flags) {
        this.entries = flags;
    };
    ServiceFeatureFlagsProvider.prototype.getFeatureFlagsFromService = function (serviceName) {
        var _this = this;
        return this.cds.executePlugin("msdynmkt_RetrieveServiceFeatureFlags", { ServiceName: serviceName }).then(function (result) {
            var featureMap = {};
            if ((result === null || result === void 0 ? void 0 : result.StatusCode) === 200) {
                var features = JSON.parse(result.ResultText);
                features.forEach(function (feature) {
                    featureMap[feature.name] = feature.state;
                });
                return featureMap;
            }
            else {
                _this.telemetryService.logError("ServiceFeatureFlags: Failed to retrieve flags from ".concat(serviceName), {
                    serviceName: serviceName,
                    resultCode: result === null || result === void 0 ? void 0 : result.StatusCode,
                    resultText: result === null || result === void 0 ? void 0 : result.ResultText
                });
            }
            return featureMap;
        });
    };
    return ServiceFeatureFlagsProvider;
}());
export { ServiceFeatureFlagsProvider };
